import {
  EInfrastructureType,
  ICoordinates,
  IInfrastructure,
  IInfrastructureItemResponse,
  IInfrastructureResponse,
} from '../utils';
import { toTimeWalkNumber } from './toTimeWalkNumber';
import { getGeoObject } from './getGeoObject';
import { IMapCoordinates, IMapGeoObject } from '@cian/frontend-newbuilding-map-component';

interface IAddInfrastructureItemToMapProps {
  item: IInfrastructureItemResponse;
  category: EInfrastructureType;
  map: Map<number, IInfrastructure>;
  year: number;
}

interface IGetInfrastructureMapByYearProps {
  infrastructureItems: IInfrastructureResponse[];
  centeredCoordinates: ICoordinates;
  year: number;
}

const addInfrastructureItemToMap = ({ item, category, map, year }: IAddInfrastructureItemToMapProps) => {
  const geoObjectsData = map.get(year)?.geoObjectsData || [];
  const { id: itemId, coordinates: itemCoordinates, distance: itemDistance, title: itemTitle } = item;

  // У нас в респонсе поле называется log - а библиотека карты требует lng
  // Желательно в будущем поправить апи
  const coordinates: IMapCoordinates = {
    lat: itemCoordinates.lat,
    lng: itemCoordinates.lon,
  };

  geoObjectsData.push({
    geoObject: getGeoObject({
      id: `${itemId}_point`,
      type: category,
      coordinates,
    }),
    infrastructureItem: {
      type: category,
      id: itemId,
      coordinates,
      title: itemTitle,
      distance: itemDistance,
      timeWalk: toTimeWalkNumber(itemDistance),
    },
  });

  map.set(year, { geoObjectsData });
};

export const getInfrastructureMapByYear = ({
  infrastructureItems,
  centeredCoordinates,
  year,
}: IGetInfrastructureMapByYearProps) => {
  const map = new Map<number, IInfrastructure>();

  infrastructureItems.forEach(infrastructure => {
    const { category, items } = infrastructure;

    items.forEach(item => {
      addInfrastructureItemToMap({
        item,
        category,
        map,
        year,
      });
    });
  });

  const currentYearGeoObjectsData = map.get(year)?.geoObjectsData || [];

  const mainObject: IMapGeoObject[] = [];
  const main = getGeoObject({
    id: '#mainObject',
    type: EInfrastructureType.Main,
    coordinates: centeredCoordinates,
  });

  mainObject.push(main);
  mainObject.forEach(geoObject => {
    currentYearGeoObjectsData.push({ geoObject, infrastructureItem: null });
  });

  map.set(year, {
    geoObjectsData: currentYearGeoObjectsData,
  });

  return map;
};
